import React from "react";
import classnames from "classnames";
import { components, OptionProps } from "react-select";

import { SelectOption } from "@vahak/core-ui/dist/components/Select";
import {
    createQuoteFormChevronIndicator,
    createQuoteFormLorryControl,
    createQuoteFormLocationControl,
    createQuoteFormLocationInput,
    createQuoteFormLocationMenu,
    createQuoteFormLocationPlaceholder,
    createQuoteFormLocationSingleValue,
    createQuoteFormMultiValueContainer,
    createQuoteFormNoOptionsMessage as createQuoteFormNoOptionsMessageBase,
    filterOptionByLabel,
    hiddenMultiValue,
    renderHighlightedText
} from "../../../../homepage-v2/load-quote/quoteFormSelectParts";

type FieldStyles = Record<string, string>;

export {
    createQuoteFormChevronIndicator,
    createQuoteFormLorryControl,
    createQuoteFormLocationControl,
    createQuoteFormLocationInput,
    createQuoteFormLocationPlaceholder,
    createQuoteFormLocationSingleValue,
    createQuoteFormMultiValueContainer,
    hiddenMultiValue
};

export const filterMarketplaceStateOption = filterOptionByLabel;

export function createQuoteFormStateOption(Styles: FieldStyles) {
    return (props: OptionProps<SelectOption<number>, boolean>) => {
        const { data, isFocused, isSelected, selectProps } = props;
        const inputValue = String(selectProps.inputValue || "");
        const isActive = isFocused || isSelected;

        return (
            <components.Option
                {...props}
                className={classnames(Styles.locationOption, isActive && Styles.locationOptionActive)}
            >
                <span className={Styles.locationOptionText}>
                    {renderHighlightedText(data.label, inputValue, Styles.locationMatch)}
                </span>
            </components.Option>
        );
    };
}

export function createQuoteFormNoOptionsMessage(Styles: FieldStyles, getMessage: (input: string) => string) {
    return createQuoteFormNoOptionsMessageBase(Styles, getMessage);
}

export function createQuoteFormLocationMenuAlways(Styles: FieldStyles) {
    return createQuoteFormLocationMenu(Styles, false);
}
